import _ from "lodash"
import moment from "moment"
import React from "react"
import PropTypes from "prop-types"
import { List } from "immutable"
import { connect } from "react-redux"
import { Table, Badge } from "antd"
import * as actions from "../redux/actions"

const statusMap = {
	Done: 0,
	OK: 1,
	NG: 2,
}

class TabContent extends React.Component {
	static propTypes = {
		regNo: PropTypes.string,
		contentHeight: PropTypes.number,
		data: PropTypes.objectOf(List),
		showContModal: PropTypes.func,
		deleteSoData: PropTypes.func,
	}

	state = {
		filteredInfo: null,
		sortedInfo: {},
	}

	_handleChange = (pagination, filters, sorter) => {
		this.setState({
			filteredInfo: filters,
			sortedInfo: sorter,
		})
	}

	render() {
		const { regNo, contentHeight } = this.props
		const { sortedInfo } = this.state
		// 加入 key
		const data = _.map(this.props.data.toJS()[regNo], (soData) => {
			return { key: soData.soNo, ...soData }
		})

		const columns = [
			{
				title: "S/O No.",
				dataIndex: "soNo",
				key: "soNo",
				sorter: (a, b) => {
					return Number(a.soNo) - Number(b.soNo)
				},
				sortOrder: sortedInfo.columnKey === "soNo" && sortedInfo.order,
				width: "20%",
			},
			{
				title: "Status",
				render: (text, record) => {
					switch (record.status) {
						case "Done": {
							return (
								<Badge status="success" text={"Done"} />
							)
						}
						case "OK": {
							return (
								<Badge status="processing" text={"OK"} />
							)
						}
						case "NG": {
							return (
								<Badge status="default" text={"NG"} />
							)
						}
						default: {
							return null
						}
					}
				},
				key: "status",
				sorter: (a, b) => {
					const an = statusMap[a.status]
					const bn = statusMap[b.status]
					return an - bn
				},
				sortOrder: sortedInfo.columnKey === "status" && sortedInfo.order,
				width: "20%",
			},
			{
				title: "Last Rel Date",
				dataIndex: "relDate",
				key: "relDate",
				sorter: (a, b) => {
					const aMoment = a.relDate ? moment(a.relDate, "YYYYMMDD hh:mm").add(1911, "y") : 0
					const bMoment = b.relDate ? moment(b.relDate, "YYYYMMDD hh:mm").add(1911, "y") : 0
					return aMoment - bMoment
				},
				sortOrder: sortedInfo.columnKey === "relDate" && sortedInfo.order,
				width: "30%",
			},
			{
				title: "Cont",
				key: "contList",
				render: (text, record) => {
					if (record.contList && record.contList.length > 0) {
						return (
							<div onClick={() => { this.props.showContModal(record.contList) }}>
								<a onClick={() => { this.props.showContModal(record.contList) }}>
									{record.contList.length}
								</a>
							</div>
						)
					} else {
						return 0
					}
				},
				width: "15%",
			},
			{
				title: "Action",
				key: "action",
				render: (text, record) => {
					return (
						<div onClick={() => { this.props.deleteSoData(this.props.regNo, record.soNo) }}>
							<a onClick={() => { this.props.deleteSoData(this.props.regNo, record.soNo) }}>
								delete
							</a>
						</div>
					)
				},
				width: "15%",
			},
		]

		return (
			<Table
				columns={columns}
				dataSource={data}
				bordered={true}
				pagination={false}
				onChange={this._handleChange}
				scroll={{ y: contentHeight - (48 + 60 + 52 + 50) }}
			/>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		contentHeight: state.getIn(["main", "contentHeight"]),
		data: state.getIn(["main", "data"]),
	}
}

const mapDispatchToProps = {
	showContModal: actions.showContModal,
	deleteSoData: actions.deleteSoData,
}

export default connect(mapStateToProps, mapDispatchToProps)(TabContent)



// WEBPACK FOOTER //
// ./src/conponents/TabContent.js